export default "__VITE_ASSET__CwCdgv50__"